import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Starfield from "./components/StarField";
import Header from "./components/Header";
import Home from "./pages/Home";
import About from "./pages/About";
import Blog from "./pages/Blog";
import Life from "./pages/Life";
import Login from "./pages/Login";
import Footer from "./components/Footer";
import AddEssay from "./pages/AddEssay";
import { useEffect, useState } from "react";
import { jwtDecode } from 'jwt-decode';
import ProtectedRoute from './pages/ProtectedRoute';


const App = () => {
    const [user, setUser] = useState(null); // will hold { username, role } or null

    useEffect(() => {
        // Check if there’s a token in local storage
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                // Check token expiry, etc. For simplicity, just set user
                setUser({ username: decoded.username, role: decoded.role });
            } catch (error) {
                console.error('Invalid token:', error);
                localStorage.removeItem('token');
            }
        }
    }, []);

    return (
        <div className="app-container">
            <Starfield />
            <Router>
                <Header />
                <main className="content">
                    <Routes>
                        {/* Example: redirect '/' to '/about' */}
                        <Route path="/" element={<Navigate to="/about" replace />} />

                        {/* Publicly accessible routes */}
                        <Route path="/about" element={<About />} />
                        <Route path="/blog" element={<Blog />} />
                        {/*<Route path="/home" element={<Home />} />*/}
                        <Route path="/life" element={<Life />} />

                        {/* The Login page (assumes your login logic sets user state on success) */}
                        <Route path="/login" element={<Login onLogin={setUser} />} />

                        {/* Protected route: Only render AddEssay if user is logged in, otherwise redirect */}
                        <Route
                            path="/add-essay"
                            element={

                                <ProtectedRoute>
                                    <AddEssay />
                                </ProtectedRoute>
                        }
                        />

                        {/* Example: additional route (same component as /about?) */}
                        <Route path="/personal-blog" element={<About />} />

                        {/* Catch-all: redirect invalid URLs to /about */}
                        <Route path="*" element={<Navigate to="/about" replace />} />
                    </Routes>
                </main>
                <Footer />
            </Router>
        </div>
    );
};

export default App;
